// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as AcademyData$LiteracyplanetClientSxEntry from "./AcademyData.res.mjs";
import * as AcademyParallax$LiteracyplanetClientSxEntry from "./AcademyParallax.res.mjs";
import * as AcademyParallaxData$LiteracyplanetClientSxEntry from "./AcademyParallaxData.res.mjs";

function AcademyIndexContainer(props) {
  var onPlayActivity = props.onPlayActivity;
  var md5 = props.md5;
  return React.createElement(AcademyData$LiteracyplanetClientSxEntry.Provider.make, {
              onPlayActivity: onPlayActivity,
              onNavActivities: props.onNavActivities,
              md5: md5,
              children: React.createElement(AcademyParallaxData$LiteracyplanetClientSxEntry.Provider.make, {
                    onPlayActivity: onPlayActivity,
                    md5: md5,
                    children: React.createElement(AcademyParallax$LiteracyplanetClientSxEntry.make, {})
                  })
            });
}

var make = AcademyIndexContainer;

export {
  make ,
}
/* react Not a pure module */
